import { useEffect, useEffectEvent, useRef, useState } from "react";
import type { CogentWidgetProps } from "./widget-types";
import type { WidgetPosition } from "./placement/use-widget-position";
import { readMountedElement } from "./read-mounted-element";
export function useWidgetNavigation({
  props,
  position,
  onBubbleClose,
}: {
  readonly props: Readonly<CogentWidgetProps>;
  readonly position: WidgetPosition;
  readonly onBubbleClose: () => void;
}) {
  const [open, setOpen] = useState(false);
  const panel = useRef<HTMLDialogElement>(null);
  const log = useRef<HTMLDivElement>(null);
  const onVisibilityChange = useEffectEvent((visible: boolean) =>
    props.onVisibilityChange?.(visible),
  );
  useEffect(() => {
    onVisibilityChange(open);
  }, [open]);

  const close = () => {
    setOpen(false);
    onBubbleClose();
    readMountedElement(position.avatar).focus();
  };
  const closeCurrent = useEffectEvent(close);
  useEffect(() => {
    if (!open) return;

    readMountedElement(panel).focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;

      event.preventDefault();
      closeCurrent();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return { open, setOpen, panel, log, close };
}
